export const DEFAULT_EPS = 1e-6;
/**
 * Internal use only. **Do NOT use in user land code!**
 */
export const SEMAPHORE = Symbol();
